import React from 'react'

const LawyerDashboardMain = () => {
  return (
    <div>LawyerDashboardMain</div>
  )
}

export default LawyerDashboardMain